// All API Call Status
export const APP_ROLES = {
	BUSINESS_ADMIN: 'businessadmin',
	BILLING_ADMIN: 'billingadmin',
	DEV_PED: 'developmentalpediatrician',
	BCBA: 'bcba', //'Board Certified Behavioral Analyst'
	RBT: 'RBT', //'Registered Behavioral Technician'
	SUPER_ADMIN: 'superadmin',
	CAREGIVER: 'caregiver'
};

export const API_STATUS = {
	COMPLETED: 'completed',
	REJECTED: 'rejected',
	PENDING: 'pending',
	LOADING: 'loading',
	CLEAR: 'clear'
};

export const ROLES = {
	ARTDIRECTOR: 'artdirector',
	ANIMATOR: 'animator',
	MODERATOR: 'moderator',
	PRACTITIONER: 'practitioner',
	VIDEOGRAPHER: 'videographer',
	ILLUSTRATOR: 'illustrator',
	ADMIN: 'admin',
	WRITER: 'writer'
};

export const isCompleteOrPending = status => isComplete(status) || isPending(status);
export const isComplete = status => status && API_STATUS.COMPLETED === status.toLowerCase();
export const isClear = status => status && API_STATUS.CLEAR === status.toLowerCase();
export const isPending = status => status && API_STATUS.PENDING === status.toLowerCase();
export const isRejected = status => status && API_STATUS.REJECTED === status.toLowerCase();
export const isLoading = status => status && API_STATUS.LOADING === status.toLowerCase();

// Session Status
export const SESSION_STATUS = {
	DRAFT: 'draft',
	SCHEDULED: 'scheduled',
	CANCELLED: 'cancelled',
	COMPLETED: 'completed'
};

export const SESSION_STATUS_LIST = [
	SESSION_STATUS.DRAFT,
	SESSION_STATUS.SCHEDULED,
	SESSION_STATUS.CANCELLED,
	SESSION_STATUS.COMPLETED
];

export const isSessionScheduled = status => status && SESSION_STATUS.SCHEDULED === status.toLowerCase();
export const isSessionCompleted = status => status && SESSION_STATUS.COMPLETED === status.toLowerCase();
export const isSessionCancelled = status => status && SESSION_STATUS.CANCELLED === status.toLowerCase();
export const isSessionDrafted = status => status && SESSION_STATUS.DRAFT === status.toLowerCase();

// User Session Status
export const USER_SESSION_STATUS = {
	REGISTERED: 'registered',
	CANCELLED: 'cancelled',
	WAITLISTED: 'waitlisted',
	COMPLETED: 'completed',
	NOSHOW: 'noshow',
	PREMIUM: 'premium'
};

export const hasUserRegisteredToSession = status => status && USER_SESSION_STATUS.REGISTERED === status.toLowerCase();
export const isUserSessionCancelled = status => status && SESSION_STATUS.CANCELLED === status.toLowerCase();
export const isUserSessionWaitlisted = status => status && SESSION_STATUS.WAITLISTED === status.toLowerCase();
export const isUserSessionCompleted = status => status && SESSION_STATUS.COMPLETED === status.toLowerCase();
export const isUserSessionNoShow = status => status && SESSION_STATUS.NOSHOW === status.toLowerCase();

export const SESSION_LEVEL = {
	L100: 'L100',
	L200: 'L200',
	L300: 'L300',
	L400: 'L400'
};
export const SESSION_LEVELS = [SESSION_LEVEL.L100, SESSION_LEVEL.L200, SESSION_LEVEL.L300, SESSION_LEVEL.L400];
export const isSessionOpenToPublic = level => level && level.toLowerCase() === SESSION_LEVEL.L100.toLowerCase();

export const CATEGORY_LIST = ['Workshop', 'Round Table', '1 x 1 - Counsel / Therapy sessions'];
